import { useEffect, useRef } from "react";
import Subscription from "../../actions/Subscription";
import Controls from "../controls/Controls";
import { Form, useForm } from "../customHelpers/useForm";
import { service } from "../../utils/utils";
import { FormControlLabel, Grid, Switch, TextField, Typography } from "@mui/material";

const numericServices = [
  "Number of SKUs",
  "Number of Users",
  "Number of Stores",
];

const checkboxServices = [
  "Activity Report",
  "Inventory Report",
  "Payment Report",
  "Sales Report",
];

const initialFValues = {
  services: [
    ...service().countables.map((name) => ({ name, value: "" })),
    ...service().reports.map((name) => ({ name, value: false })),
  ],
  submitting: false,
};

const AddOrganizationSubscription = ({
  NotifyMessage,
  setOpenPopup,
  recordForEdit,
  getSubscription,
  edite,
  id,
}) => {
  const { addService } = Subscription();
  const firstFieldRef = useRef(null);

  useEffect(() => {
    if (firstFieldRef.current) {
      firstFieldRef.current.focus();
    }
  }, []);

  const validate = (fieldValues = values) => {
    const temp = {};
    let isValid = true;

    values.services.forEach((item, i) => {
      if (
        numericServices.includes(item.name) &&
        (item.value === "" || isNaN(item.value))
      ) {
        temp[`services[${i}].value`] = "Required and must be a number";
        isValid = false;
      }
    });

    setErrors(temp);
    return isValid;
  };

  const { values, errors, setValues, handleInputChange, setErrors, resetForm } =
    useForm(initialFValues, true, validate);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validate()) {
      setValues({ ...values, submitting: true });

      const payload = {
        subscription_Id: id,
        services: values.services.map((s) => ({
          name: s.name,
          value: checkboxServices.includes(s.name)
            ? s.value
              ? "on"
              : "off"
            : s.value,
        })),
      };

      addService(payload).then((data) => {
        if (data.err) {
          setValues({ ...values, submitting: false });
          NotifyMessage({ message: data.err, type: "error" });
        } else if (data.subscription) {
          NotifyMessage({
            message: "Subscription service successfully created",
            type: "success",
          });
          setOpenPopup(false);
          resetForm();
          getSubscription();
        }
      });
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        {values.services.map((item, index) => {
          const isSwitch = checkboxServices.includes(item.name);

          return (
            <Grid item xs={12} key={index}>
              {isSwitch ? (
                <FormControlLabel
                  control={
                    <Switch
                      color="primary"
                      checked={item.value === true || item.value === "on"}
                      onChange={(e) => {
                        const updated = [...values.services];
                        updated[index].value = e.target.checked;
                        setValues({ ...values, services: updated });
                      }}
                      name={`services[${index}].value`}
                    />
                  }
                  label={item.name}
                />
              ) : (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "1rem",
                    marginLeft: "1.5rem",
                  }}
                >
                  <Typography variant="body1" style={{ minWidth: "150px" }}>
                    <strong>{item.name}</strong>
                  </Typography>
                  <TextField
                    size="small" 
                    inputRef={index === 0 ? firstFieldRef : null}
                    name={`services[${index}].value`}
                    type="number"
                    label="Value"
                    value={item.value}
                    onChange={(e) => {
                      const updated = [...values.services];
                      updated[index].value = e.target.value;
                      setValues({ ...values, services: updated });
                    }}
                    fullWidth={false}
                    style={{ width: "150px" }} 
                    error={Boolean(errors[`services[${index}].value`])}
                    helperText={errors[`services[${index}].value`] || ""}
                    InputProps={{
                      style: {
                        height: "40px",
                        fontSize: "0.875rem",
                      },
                    }}
                  />
                </div>
              )}
            </Grid>
          );
        })}

        <Grid item xs={12}>
          <div>
            <Controls.Button
              disabled={values.submitting}
              text={
                edite
                  ? values.submitting
                    ? "Editing..."
                    : "Done"
                  : values.submitting
                  ? "Adding..."
                  : "Add"
              }
              variant="contained"
              className="Button"
              type="submit"
            />
            <Controls.Button
              text="Cancel"
              variant="contained"
              className="Button"
              onClick={() => setOpenPopup(false)}
            />
          </div>
        </Grid>
      </Grid>
    </Form>
  );
};

export default AddOrganizationSubscription;
